import { makeStyles } from "@material-ui/core";
import { color } from "../../../../assets/const/color";

export const useStyles = makeStyles(() => ({
  root: {
    "& p": {
      fontFamily: "inter !important",
    },
  },
  yes_btn: {
    padding: "15px 25px",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.lightGreen} !important`,
    border: `1px solid ${color.lightGreen} !important`,
    borderRadius: "50px !important",
    margin: "0px !important",
  },
  no_btn: {
    marginLeft: "5px !important",
    padding: "15px 25px",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `red !important`,
    borderRadius: "50px !important",
    margin: "0px !important",
    border: `1px solid red !important`,
  },
  editCourse: {},
  add_course_text: {
    fontFamily: "inter !important",
    fontSize: "18px !important",
    fontWeight: "700 !important",
    color: "#00473E",
  },
  label: {
    color: "#374151",
    fontFamily: "inter !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
  },
  form_add_course: {
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
  },
  add_course_btn: {
    width: "100%",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },
  cancel_btn: {
    width: "100%",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `#979797 !important`,
    background: `#EAECF0 !important`,
  },
  error: {
    color: "red",
    fontSize: "12px",
  },
}));
